import { useMemo } from 'react';
import { useReactTable } from '@tanstack/react-table';
import {
  getCoreRowModel,
  getExpandedRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getGroupedRowModel,
  getPaginationRowModel,
  getSortedRowModel,
} from '@tanstack/react-table';
import { isEntryReconciled, isTransferReconciled } from '../../helpers/reconciliationHelpers';

export const useEntriesTableConfig = (
  columns,
  journalEntriesFilteredByDate,
  isLoadingJournalEntriesFilteredByDate,
  columnFilters,
  setColumnFilters,
  sorting,
  setSorting,
  globalFilter,
  setGlobalFilter,
  columnVisibility,
  setColumnVisibility,
  columnResizeMode,
  setColumnResizeMode,
  rowSelection,
  setRowSelection,
  grouping,
  setGrouping,
  expanded,
  setExpanded,
  getPercentPaid,
  getCheckedRows
) => {
  // Process table data to include correct reconciliation status
  const processedTableData = useMemo(() => {
    if (!journalEntriesFilteredByDate || !journalEntriesFilteredByDate.data) {
      return [];
    }

    return journalEntriesFilteredByDate.data.map((entry) => {
      const isReconciled =
        entry.journalEntryType === 5 ? isTransferReconciled(entry) : isEntryReconciled(entry);

      return {
        ...entry,
        isReconciliated: isReconciled ? 'Sim' : 'Não',
      };
    });
  }, [journalEntriesFilteredByDate]);

  const table = useReactTable({
    columns,
    data: !isLoadingJournalEntriesFilteredByDate && processedTableData,
    getRowId: (row) => row.id || row.Id,
    filterFns: {
      checkedRows: getCheckedRows,
    },
    aggregationFns: {
      percentPaid: getPercentPaid,
    },
    state: {
      columnFilters,
      sorting,
      globalFilter,
      columnVisibility,
      columnResizeMode,
      rowSelection,
      grouping,
      expanded,
    },
    initialState: {
      pagination: {
        pageSize: 500,
        pageIndex: 0,
      },
    },
    enableRowSelection: true,
    onRowSelectionChange: setRowSelection,
    onColumnFiltersChange: setColumnFilters,
    onColumnVisibilityChange: setColumnVisibility,
    onGlobalFilterChange: setGlobalFilter,
    onGroupingChange: setGrouping,
    onExpandedChange: setExpanded,
    onSortingChange: setSorting,
    autoResetExpanded: false,
    getExpandedRowModel: getExpandedRowModel(),
    getGroupedRowModel: getGroupedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    debugTable: false,
    debugHeaders: false,
    debugColumns: false,
  });

  return {
    table,
    processedTableData,
  };
};
